import { Link } from 'react-router-dom';
import { Movie } from '@/mocks/movies';

interface RankingSectionProps {
  movies: Movie[];
}

export default function RankingSection({ movies }: RankingSectionProps) {
  return (
    <section>
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">口碑排行</h2>
          <p className="text-sm text-foreground-500 mt-1">评分最高的电影推荐</p>
        </div>
      </div>

      <div className="bg-background-100 rounded-xl p-5 md:p-6">
        <div className="space-y-1">
          {movies.map((movie, index) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="flex items-center gap-4 py-3 px-3 rounded-lg hover:bg-background-200 transition-colors group"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading text-sm font-bold flex-shrink-0 ${
                index === 0 ? 'bg-accent-500 text-background-50' :
                index === 1 ? 'bg-secondary-500 text-background-50' :
                index === 2 ? 'bg-primary-400 text-background-50' :
                'bg-background-300 text-foreground-600'
              }`}>
                {index + 1}
              </div>

              <div className="w-12 h-16 rounded overflow-hidden flex-shrink-0">
                <img src={movie.poster} alt={movie.title} className="w-full h-full object-cover object-top" />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                  {movie.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 truncate">
                  {movie.actors.slice(0, 2).join(' / ')}
                </p>
              </div>

              <div className="flex items-center gap-1 text-accent-500 flex-shrink-0">
                <i className="ri-star-fill text-xs"></i>
                <span className="text-sm font-bold">{movie.rating}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}